import { render, staticRenderFns } from "./ComeDownMiddle.vue?vue&type=template&id=0188242a&scoped=true&"
import script from "./ComeDownMiddle.vue?vue&type=script&lang=js&"
export * from "./ComeDownMiddle.vue?vue&type=script&lang=js&"
import style0 from "./ComeDownMiddle.vue?vue&type=style&index=0&id=0188242a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188242a",
  null
  
)

export default component.exports